module.exports = new __parcel__URL__("GT_P_1Blau_reduziert_005.47c81fb0.json").toString();